export const iconFontAwesomeHumanitarianShopLock = (
	<i className="fa-solid fa-shop-lock"></i>
);
